import React, { useState } from 'react';
import { Foldable, HTML, ToggleArrow, YFMWrapper } from '../../components';
import Link from '../../components/Link/Link';
import { Col, Row } from '../../grid';
import { Content } from '../../sub-blocks';
import { block } from '../../utils';
import './Questions.css';
const b = block('QuestionsBlock');
const FaqMicrodataValues = {
    PageType: 'https://schema.org/FAQPage',
    QuestionType: 'https://schema.org/Question',
    QuestionProp: 'mainEntity',
    QuestionNameProp: 'name',
    QuestionTextProp: 'text',
    AnswerType: 'https://schema.org/Answer',
    AnswerProp: 'acceptedAnswer',
    AnswerTextProp: 'text',
};
const QuestionsBlock = (props) => {
    const { title, text, additionalInfo, links, buttons, items } = props;
    const [opened, setOpened] = useState([0]);
    const toggleItem = (index) => {
        let newState;
        if (opened.includes(index)) {
            newState = opened.filter((intemIndex) => intemIndex !== index);
        }
        else {
            newState = [...opened, index];
        }
        setOpened(newState);
    };
    return (React.createElement("div", { className: b(), itemScope: true, itemType: FaqMicrodataValues.PageType },
        React.createElement(Row, null,
            React.createElement(Col, { sizes: { all: 12, md: 4 } },
                React.createElement("div", { className: b('title') },
                    React.createElement(Content, { title: title, text: text, additionalInfo: additionalInfo, links: links, buttons: buttons, colSizes: { all: 12, md: 12 } }))),
            React.createElement(Col, { sizes: { all: 12, md: 8 } }, items.map(({ title: itemTitle, text: itemText, link, listStyle = 'dash' }, index) => {
                const isOpened = opened.includes(index);
                return (React.createElement("div", { key: itemTitle, className: b('item'), itemScope: true, itemProp: FaqMicrodataValues.QuestionProp, itemType: FaqMicrodataValues.QuestionType },
                    React.createElement("h4", { className: b('item-title'), onClick: () => toggleItem(index) },
                        React.createElement(HTML, { itemProp: FaqMicrodataValues.QuestionNameProp }, itemTitle),
                        React.createElement(ToggleArrow, { open: isOpened, size: 16, type: 'vertical', iconType: "navigation", className: b('arrow') })),
                    React.createElement(Foldable, { isOpened: isOpened },
                        React.createElement("div", { className: b('text'), itemScope: true, itemProp: FaqMicrodataValues.AnswerProp, itemType: FaqMicrodataValues.AnswerType },
                            React.createElement(YFMWrapper, { content: itemText, modifiers: {
                                    constructor: true,
                                    constructorListStyle: true,
                                    constructorListStyleDash: listStyle === 'dash',
                                }, itemProp: FaqMicrodataValues.QuestionTextProp }),
                            link && React.createElement(Link, Object.assign({}, link, { className: b('link') }))))));
            })))));
};
export default QuestionsBlock;
